<template>
  <BarChart :options="stackedBarChartOptions"></BarChart>
</template>

<script>
import BarChart from '@wizer/core/components/chart/BarChart'
import ChartMixin from '@/mixins/ChartMixin'

export default {
  name: 'StackedBarChartWrapper',
  mixins: [ChartMixin],
  components: {
    BarChart,
  },
  created() {
    this.$store.dispatch('setIsFillMissingDates', true)
  },
  computed: {
    stackedBarChartOptions() {
      if (this.chartOptions.series) {
        this.chartOptions.series.forEach((series) => {
          series.stack = 'stack'
        })
      }
      return this.chartOptions
    },
  },
}
</script>
